import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { TravelZoneEntity } from '../../entities/travel-zone.entity';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { TravelZoneActionTypes } from '../actions/travel-zone.actions';

export const TRAVEL_ZONE_KEY = 'travel-zone';

export interface TravelZoneState extends EntityState<TravelZoneEntity> {
    fetched: boolean;
    latestUpdatedAt: Date;
}

const adapter = createEntityAdapter<TravelZoneEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

export const travelZoneReducer = createReducer(
    initialState,
    on(TravelZoneActionTypes.LoadSuccess, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, { ...state, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt }),
    ),
    on(TravelZoneActionTypes.AddSuccess, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(TravelZoneActionTypes.ChangeSuccess, (state, { Payload }) => adapter.setOne(Payload, state)),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllTravelZone = selectAll;
export const selectTravelZoneEntities = selectEntities;

export const selectTravelZoneFetched = (state: TravelZoneState) => state.fetched;
export const selectTravelZoneLatestUpdatedAt = (state: TravelZoneState) => state.latestUpdatedAt;
